export const CREATE_TENANT_USER_BEGIN = "CREATE_TENANT_USER_BEGIN";
export const CREATE_TENANT_USER_SUCCESS = "CREATE_TENANT_USER_SUCCESS";
export const CREATE_TENANT_USER_FAIL = "CREATE_TENANT_USER_FAIL";